import { Component, OnInit } from '@angular/core';
import {ServicesComponent} from "../services.component";
import {WebDesignComponent} from "./web-design.component";

@Component({
  selector: 'app-branding',
  template: `
     <div class="service-detail" id="top">
        <h2><span class="bottomBorder" style="padding-bottom: 4%;">BRAN</span>DING</h2>
        <div class="scale-less-margin"></div>
        <article>At Creative Digital we will encourage you to focus on many areas of marketing straight away,
         but a strong brand will increase the number of opportunities for growth.
          Therefore as a company we will recommend you to hand branding over to our brand expert. </article>
        <article style="margin-bottom: 6%">It is always essential for branding to be correct,
         so therefore call our outstanding expert at Studio 116 up now and we will arrange some time to discuss and go through your essential business needs.</article>
        <div class="details-container first">
          <div class="checked"></div>
          <h5>Social Media Management</h5></div>
        <p style="display: block" class="slider">There are many variations of passages available, randomised words which don't look even slightly believable. If you are going to Lorem Ipsum. </p>
        <div class="details-container second">
          <div class="checkMark"></div>
          <h5>Photography and Videography</h5></div>
        <p class="slider">There are many variations of passages available, randomised words which don't look even slightly believable. If you are going to Lorem Ipsum. </p>
        <div class="details-container third">
          <div class="checkMark"></div>
          <h5>Online Portfolios</h5></div>
        <p class="slider">There are many variations of passages available, randomised words which don't look even slightly believable. If you are going to Lorem Ipsum. </p>
       </div>
  `,
  styleUrls: ['./branding.component.css']
})
export class BrandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.slider();
    WebDesignComponent.firstStart(this, 5);
  }

  slider () {
    $('.first').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.second').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.third').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.forth').click(function () {
      WebDesignComponent.initializeSlide(this);
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/descriptionComponents/branding.component.ts